exports.components = {
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-basic-page-index-tsx": () => import("./../../../src/templates/basicPage/index.tsx" /* webpackChunkName: "component---src-templates-basic-page-index-tsx" */)
}

